export default "__VITE_ASSET__C89Oh7zK__"